import { FC } from 'react'

import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import SurveyForEndedCampaign from 'src/Components/SideBarSurveys/SurveyForEndedCampaign'
import { getValueOrEmptyString } from 'src/Helpers/layoutHelpers'
import { CampaignStatusEnum } from 'src/Types'
import { getClosedTypeformIds } from 'src/Redux/typeform-process'
import { useSpotifyCampaignDetails } from 'src/Redux/campaignDetailsApi/useSpotifyCampaignDetails'
import { useAppSelector } from 'src/Hooks/redux'
import { getUserEmail } from 'src/Redux/auth-process/userSlice/selectors'

export const Survey: FC = () => {
  const { t } = useTranslation()

  const closedTypeformIds = useSelector(getClosedTypeformIds)
  const { campaignDetails } = useSpotifyCampaignDetails()
  const userEmail = useAppSelector(getUserEmail)

  const isAppropriateCampaignStatus =
    campaignDetails?.status &&
    campaignDetails?.status === CampaignStatusEnum.ENDED

  const isClosedCampaign = Boolean(
    closedTypeformIds.includes(String(campaignDetails?.id)),
  )

  if (!isAppropriateCampaignStatus || isClosedCampaign) {
    return null
  }

  return (
    <SurveyForEndedCampaign
      userEmail={userEmail}
      campaignId={`${campaignDetails?.id ?? ''}`}
      campaignType={`${getValueOrEmptyString(campaignDetails?.type)}`}
      campaignName={`${getValueOrEmptyString(
        campaignDetails?.Track?.track_name,
      )}`}
      isFeed={campaignDetails?.is_feed}
      id='VP92h7z5'
      text={t('sidebar.shareFeedback')}
    />
  )
}
